import React, { useState } from "react";

import { editWidgetApi } from "api/report";

import { valueStrings } from "constants/constantStrings";

import DupontButton from "components/DupontButton";
import InputBox from "components/InputBox";

import { ReportStrings } from "../../../constants/constantStrings";

import "./index.scss";

const ReportComment = ({ report, parentStyle, LayoutId }) => {
  const [comment, setComment] = useState( report.Attributes.Comments);

  const [initialComment, setInitialComment] = useState(report.Attributes.Comments || "");
  

  const [isTextBoxFocused, setIsTextBoxFocused] = useState(false);

  const saveComment = async value => {
    const paylod = { LayoutID: LayoutId, Id: report.Id, Attributes: { Comments: value } };
    try {
      const response = await editWidgetApi(paylod);
      if (response) {
        report.Attributes.Comments = value;
        setInitialComment(value);
        setComment(value);
      }
    } catch (error) {}
  };

  const onKeyDown = event => {
    if (event.keyCode === 27) {
      handleCancel();
    }
  };

  const handleChange = value => {
    setComment(value);
    setIsTextBoxFocused(true);
  };

  const onSaveClicked = () => {
    saveComment(comment);
    setIsTextBoxFocused(false);
  };

  const handleCancel = () => {
    setComment(initialComment);
    setIsTextBoxFocused(false);
  };

  const onFocus = event => {
    setTimeout(() => {
      setIsTextBoxFocused(true);
    }, 500);
  };

  return (
    <div className={`${parentStyle}`}>
      <InputBox
        value={comment}
        onChange={handleChange}
        placeholder={ReportStrings.addCommentHere}
        onFocus={onFocus}
        rows="10"
        onEscapeKeyDown={onKeyDown}
        maxLength="500"
        maxHeight="170px"
      />
      <div className={"d-flex jc-end padding10"}>
        <DupontButton type="tertiary" customClass="cancelBtn margin-right-10" onClick={handleCancel} disabled={!isTextBoxFocused}>
          {valueStrings.cancel}
        </DupontButton>
        <DupontButton type="tertiary" customClass="cancelBtn" onClick={onSaveClicked} disabled={comment === initialComment || !isTextBoxFocused}>
          {valueStrings.save}
        </DupontButton>
      </div>
    </div>
  );
};

export default ReportComment;
